import React, { useState } from 'react'
import {
  DomainTableColumn,
  DomainToSelect,
  DomainToSetup,
  EMPTY_DOMAIN,
} from '../../CrossSaleModal.types'
import { DomainTableRow, DomainTableCell } from '../Steps.styled'
import { ButtonWithIcon, Input } from '@clickcease/cc-client-components-lib'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/pro-light-svg-icons'
import { useAddDomain } from 'Features/domainsManagement/api/addDomain'
import { useTranslation } from 'react-i18next'
import { validateDomain } from 'Utils/validation'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const AddDomainRow = ({
  setDomainsToSelect,
  columns,
  isBotMitigation,
  isDisabled,
}: {
  setDomainsToSelect: (d: DomainToSelect) => void
  columns: DomainTableColumn[]
  isBotMitigation: boolean
  isDisabled: boolean
}) => {
  const { t } = useTranslation('general')
  const [domain, setDomain] = useState<DomainToSetup>({
    address: '',
    wordpress: false,
    isBzMonitor: false,
    isSelected: false,
  })
  const { mutate, isLoading } = useAddDomain()
  const domainToCreateBody = isBotMitigation
    ? { address: domain.address, paidMarketing: false, botZapping: true }
    : { address: domain.address, paidMarketing: true, botZapping: false }

  const domainAdressIsValid = domain.address.length > 0 && validateDomain(domain.address)

  const handleDomainInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDomain({ ...domain, address: e.target.value })
  }

  const resetDomain = () => {
    setDomain(EMPTY_DOMAIN)
  }

  const addDomain = () => {
    mutate(
      { domains: [domainToCreateBody] },
      {
        onSuccess: (data) => {
          if (data && !(data instanceof Error) && data.data) {
            const addedDomain = data.data.addedDomains[0]

            setDomainsToSelect({
              isNewlyCreated: true,
              isSelected: true,
              wordpress: domain.wordpress,
              isBzMonitor: false,
              id: addedDomain.id,
              address: addedDomain.address,
              paidMarketingConnected: false,
              botZappingConnected: false,
              botZappingPluginActivated: false,
              tagHashCode: addedDomain.tagHash,
              tagUrl: addedDomain.tagUrl ?? '',
              tagId: addedDomain.tagId,
            })
            resetDomain()
          }
        },
      }
    )
  }

  return (
    <DomainTableRow>
      {columns.map((cell, indx) => {
        if (cell.key !== 'address') {
          return (
            <DomainTableCell
              flexStart={cell.flexStart}
              css={{ flex: cell.flex }}
              key={cell.accessor}
              isPadded={columns.length === indx + 1}
            >
              <span />
            </DomainTableCell>
          )
        } else {
          return (
            <DomainTableCell
              flexStart={cell.flexStart}
              css={{ flex: cell.flex }}
              key={cell.accessor}
            >
              <Input
                placeholder={t('crossSaleModal.domainInputPlaceholder')}
                value={domain.address}
                onChange={handleDomainInput}
                disabled={isLoading || isDisabled}
              />
              <ButtonWithIcon
                iconLeft={<FontAwesomeIcon icon={faCirclePlus as IconProp} />}
                text={t('crossSaleModal.addDomainButton')}
                variant={'outline'}
                disabled={!domainAdressIsValid || isLoading || isDisabled}
                onClick={addDomain}
                loading={isLoading}
              />
            </DomainTableCell>
          )
        }
      })}
    </DomainTableRow>
  )
}
